import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/eye.png'


const _withScopeId = n => (_pushScopeId("data-v-32b104c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "article bx" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "sub-title" }
const _hoisted_5 = { class: "name fl" }
const _hoisted_6 = { class: "time fl" }
const _hoisted_7 = { class: "iview fr" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 2,
  class: "pagination"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top" }, "公益捐款", -1))

import { MessageFetch, StoryFetch } from '@/api/request';
import {
  ISjqnwArticleProps,
  IStoryDescProps,
  SjqnwArticleProps,
  ScholarshipStoryInfoProps
} from '@/api/type';
import Recommend from '@/components/Recommend.vue';
import { nextTick, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import config from '../_config';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();

const scholarshipIds = router?.currentRoute?.value?.query?.scholarshipId;
const articleIds = router?.currentRoute?.value?.query?.articleId;
const articleId = Array.isArray(articleIds)
  ? (articleIds[0] as string)
  : articleIds || '';
const scholarshipId = Array.isArray(scholarshipIds)
  ? (scholarshipIds[0] as string)
  : scholarshipIds || '';
const artDetail = ref<SjqnwArticleProps>();
const storyDetail = ref<IStoryDescProps>();
const scholarshipStoryInfo = ref<ScholarshipStoryInfoProps>();
const init = async() => {
  const authToken = window.localStorage.getItem('authToken') || '';

  if (scholarshipId) {
    const storyRes = await StoryFetch.getStoryDetail({
      scholarshipId,
      authToken
    });
    if (storyRes.code === '00') {
      storyDetail.value = storyRes.body[0];
      const resourcesUrl = storyRes.body[0]?.resourcesUrl;
      const $script = document.createElement('script');
      $script.type = 'text/javascript';
      $script.charset = 'utf-8';
      $script.src = config.imgPosterBaseURL + resourcesUrl;
      $script.onload = () => {
        scholarshipStoryInfo.value = window?.storyInfo;
        if (document.body.clientWidth < 993) {
          nextTick(() => {
            // 写入操作
            const oImg = document.querySelectorAll('img');
            for (var i = 0; i < oImg.length; i++) {
              oImg[i].style.maxWidth = '80vw';
              oImg[i].style.height = 'auto';
            }
          });
        }
      };
      window.document.body.appendChild($script);
      await StoryFetch.updateReadNum({ scholarshipId });
    }
  } else {
    const res = await MessageFetch.getArticleDetail({
      sjqnwArticleType: '1',
      id: articleId
    });
    if (res.code === '00') {
      artDetail.value = res.body;
      await MessageFetch.sjqnwArticleBrowse({ id: articleId });
    }
  }
};
const like = async() => {
  if (scholarshipId) {
    const res = await StoryFetch.updateFabulousNum({
      fabulousNum: storyDetail.value?.fabulous ? -1 : 1, // （用户第一次触发传1 第二触发取消点赞传 -1）
      scholarshipId: storyDetail.value?.scholarshipId || ''
    });
    if (res.code === '00') {
      storyDetail.value.fabulous = !storyDetail.value.fabulous;
    }
  } else {
    const resFabulous = await StoryFetch.sjqnwArticleGiveLike({
      likeType: artDetail.value?.like ? -1 : 1, // （用户第一次触发传1 第二触发取消点赞传 -1）
      id: artDetail.value?.id || ''
    });
    if (resFabulous.code === '00') {
      artDetail.value.like = !artDetail.value.like;
    }
  }
};
const toDetail = (item?: ISjqnwArticleProps) => {
  router.push({
    name: 'article',
    query: { articleId: item?.id }
  });
};
const toRun = () => {
  router.push({
    name: 'welfareActivity',
    query: { type: 3 }
  });
};
onMounted(() => {
  init();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(artDetail.value?.articleTitle || storyDetail.value?.articleTitle), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(artDetail.value?.author || '原创'), 1),
        _createElementVNode("div", _hoisted_6, " 更新日期：" + _toDisplayString(artDetail.value?.updateTime || storyDetail.value?.updateTime), 1),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createTextVNode(" " + _toDisplayString(artDetail.value?.readNumber || storyDetail.value?.readNum), 1)
        ])
      ]),
      _createElementVNode("div", {
        class: "detail",
        innerHTML: artDetail.value?.content || scholarshipStoryInfo.value?.textPre
      }, null, 8, _hoisted_9),
      (storyDetail.value?.fabulous || artDetail.value?.like)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "like",
            onClick: like
          }, " 点赞 "))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "like not",
            onClick: like
          }, "点赞")),
      (artDetail.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (artDetail.value?.sjqnwPreArticle?.id)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "pagination-item",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (toDetail(artDetail.value?.sjqnwPreArticle)))
                }, " 上一篇：" + _toDisplayString(artDetail.value?.sjqnwPreArticle.articleTitle), 1))
              : _createCommentVNode("", true),
            (artDetail.value?.sjqnwNextArticle?.id)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "pagination-item",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (toDetail(artDetail.value?.sjqnwNextArticle)))
                }, " 下一篇：" + _toDisplayString(artDetail.value?.sjqnwNextArticle.articleTitle), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", { class: "welfare" }, [
        _hoisted_11,
        _createElementVNode("div", {
          class: "bottom",
          onClick: toRun
        }, "公益跑团")
      ])
    ]),
    _createVNode(Recommend)
  ]))
}
}

})